import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import FormInput from '../../../../../library/form/components/FormInput';

//ISSUE MATERIAL ROW
const ProdIOTIssMatRow = (props) => {
    const { formObject, viewData, index, rowKey } = props;

    const rowCss = formObject.getValueFromKey(viewData, "dataList.cssClass", "");

        return (
            <ul className={`uiDPEditLine ${rowCss}`}>
                <li className="uiColumnCenter uiColumn50">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                    action={{ paramName: "variation2Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyAvail" }} />
                </li>
                
                <li className="uiColumnCenter uiColumn130">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyIssued" }} />
                    <div style={{float:"left"}}> 
                        <FormInput formObject={formObject} className="uiWidth55 uiSpacerH5" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'issueQty1',
                            actionParam: {formulaSource: "IQ1", updateQty : "1", actionType:"updateQty"}}} />
                        <FormInput formObject={formObject} className="uiWidth55" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'issueQty2', 
                            actionParam: {formulaSource: "IQ2", updateQty : "1", actionType:"updateQty"}}} />
                    </div>
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "remark" }} />
                </li>
            </ul>
        )
}

export default ProdIOTIssMatRow
